export interface IReservationTypeDetails {
  id: string;
  type: string;
  calculationNumber: string;
  status: string;
  statusName: string;
  statusRootId: number;
  propertyName: string;
  propertyId: string;
  guestId: string;
  guestFirstName: string;
  guestLastName: string;
  guestPhone: string;
  guestMobile: string;
  guestCountry: string;
  guestEmail: string;
  guestLanguage: string;
  renterId: string;
  renterFullName: string;
  renterEmail: string;
  renterMobile: string;
  renterPhone: string;
  totalDays: number;
  totalGuests: number;
  grownUps: number;
  teens: number;
  children: number;
  babies: number;
  reservationLanguageRootId: number;
  createdOn: string;
  dateFrom: string;
  dateTo: string;
  paidPrice: number;
  paidPriceCurrencySymbol: string;
  unPaidPrice: number;
  unPaidPriceCurrencySymbol: string;
  totalPrice: number;
  totalPriceCurrencySymbol: string;
  purchasePrice: number;
  currencyIso: string;
  currencySymbol: string;
  currencyRootId: number;
  source: string;
  unitCode: string;
  unitName: string;
  unitId: string;
  unitHoldingDateTo: string | null;
  paymentSource: string;
  paymentModel: string;
  paymentMethod: string;
  subagent: string;
  subagentEmail: string;
  subagentId: string;
  subagentLink: string;
  subagentLogo: string;
  affiliate: string;
  affiliateId: string;
  affiliateRootID: number | null;
  office: string;
  couponCode: string;
  note: string;
  timeOfArrival: string | null;
  unitTypeId: number;
  calculations: IReservationTypeDetailsCalculations[];
  reservationId: string | null;
  overlappedReservationIds: TOverlappedReservation[] | null;
  renterOptionDate: string | null;
}

export enum EOverlapType {
  Calculation = 'KAL',
  HoldEvent = 'ZAU',
  FictionalCalculation = 'KAL-Fiktivna',
}

export type TOverlappedReservation = {
  value: string;
  label: string;
};

export type IReservationTypeDetailsCalculations = {
  calculationId: string;
  calculationNumber: string;
  createdOn: string;
  statusCode: string;
  statusName: string;
};
